import React from 'react'
import ReactDOM from 'react-dom'

interface DropdownPortalProps {
  children: React.ReactNode
  triggerRect?: DOMRect
  position: 'left' | 'right'
  blockOffset: number
}

const portalTargetId = 'dropdown-portal-target'

const DropdownPortal: React.FC<DropdownPortalProps> = ({
  children,
  triggerRect,
  position,
  blockOffset,
}) => {
  let portalTarget = document.getElementById(portalTargetId)

  if (!portalTarget) {
    portalTarget = document.createElement('div')
    portalTarget.id = portalTargetId
    portalTarget.style.position = 'fixed'
    portalTarget.style.top = '0'
    portalTarget.style.left = '0'
    portalTarget.style.zIndex = '9999'
    document.body.appendChild(portalTarget)
  }

  const positionStyles: React.CSSProperties = triggerRect
    ? {
        position: 'absolute',
        zIndex: 1000,
        top: triggerRect.top + triggerRect.height + blockOffset,
        left:
          position === 'left'
            ? triggerRect.left
            : triggerRect.right + triggerRect.width,
        transform: position === 'right' ? 'translateX(-100%)' : 'none',
      }
    : {}

  return ReactDOM.createPortal(
    <div style={positionStyles} className='dropdown-portal'>
      {children}
    </div>,
    portalTarget
  )
}

export default DropdownPortal
